import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  url: string = environment.api.endpoint;
  identityUrl: string = environment.api.identity;

  constructor(private http: HttpClient) { }

  getUserById(id: string): any{
    return this.http.get(`${this.url}/account/${id}`);
  }

  updateUser(id: string, data: any): any{
    return this.http.put(`${this.url}/account/${id}`, data);
  }

  /* PUT ALL NEW METHODS BELOW HERE */

  getUserByAuth0Id(id: string): any{
    return this.http.get(`${this.identityUrl}/identityuser/auth0/${id}`);
  }

  regenerateApiKey(): Observable<string> {
    return this.http.post(`${this.identityUrl}/identityuser/regenerateapikey`, {}, { responseType: 'text' });
  }

  updateUserAccount(id: string, data: any): any{
    return this.http.post(`${this.identityUrl}/account/update/${id}`, data);
  }
  
  getStripeCustomer(data: any): any{
    return this.http.post(`${this.identityUrl}/account/customer`, data);
  }

  getStripeCustomerPaymentMethods(customerId: string): any{
    return this.http.get(`${this.identityUrl}/account/customer/paymentmethods/${customerId}`);
  }

  deleteStripeCustomerPaymentMethod(id): any{
    return this.http.delete(`${this.identityUrl}/account/customer/paymentmethod/delete/${id}`);
  }

  updateStripeCustomerPaymentMethod(id, data): any{
    return this.http.put(`${this.identityUrl}/account/customer/paymentmethod/update/${id}`, data);
  }

}
